import React, { useState, useContext, useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import AuthContext from '../../contexts/auth';
import SidebarContext from '../../contexts/sidebar';
import Options from '../Sidebar/Options/indexRoles';
import { translate } from '../../utils/Common';
import { LuChevronDown } from 'react-icons/lu';
import styles from './MenuDrawer.module.css';

const MenuDrawer = ({ isOpen, onClose }) => {
    const userContext = useContext(AuthContext);
    const sidebarContext = useContext(SidebarContext);
    const history = useHistory();
    const drawerRef = useRef(null);
    const [expandedItems, setExpandedItems] = useState({});

    // Obtener todas las opciones del sidebar
    const allOptions = Options(userContext.user) || [];
    
    // Mostrar todas las opciones en el drawer (incluyendo Home y Packages)
    const filteredOptions = allOptions.filter(option => option !== null && option !== undefined);
    
    // Reiniciar el estado cuando se cierra el drawer
    useEffect(() => {
        if (!isOpen) {
            setExpandedItems({});
        }
    }, [isOpen]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (drawerRef.current && !drawerRef.current.contains(event.target)) {
                onClose();
            }
        };

        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
            document.body.style.overflow = 'hidden';
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.body.style.overflow = '';
        };
    }, [isOpen, onClose]);

    const toggleSubmenu = (index) => {
        setExpandedItems(prev => {
            const newState = {
                ...prev,
                [index]: !prev[index]
            };
            return newState;
        });
    };

    const handleItemClick = (item, index) => {
        // Verificar si tiene submenu de manera más robusta
        const hasSubmenu = item.subNav && 
                          Array.isArray(item.subNav) && 
                          item.subNav.length > 0;
        
        if (hasSubmenu) {
            // Si tiene submenu, toggle el submenu
            toggleSubmenu(index);
        } else {
            // Si no tiene submenu, navegar y cerrar drawer
            history.push(item.path);
            sidebarContext.handleChangeCurrentPage(item.title);
            onClose();
        }
    };

    const handleSubmenuItemClick = (subItem, parentTitle) => {
        history.push(subItem.path);
        sidebarContext.handleChangeCurrentPage(subItem.title);
        onClose();
    };

    if (!isOpen) return null;

    return (
        <div className={styles.overlay} onClick={onClose}>
            <div 
                ref={drawerRef}
                className={styles.drawer}
                onClick={(e) => e.stopPropagation()}
            >
                <div className={styles.drawerHeader}>
                    <h3 className={styles.drawerTitle}>{translate("sidebar.menu.title")}</h3>
                    <button 
                        className={styles.closeButton}
                        onClick={onClose}
                        aria-label={translate("global.close")}
                    >
                        ×
                    </button>
                </div>
                
                <div className={styles.drawerContent}>
                    {filteredOptions.length > 0 ? (
                        <ul className={styles.menuList}>
                            {filteredOptions.map((item, index) => {
                                const isExpanded = expandedItems[index] === true;
                                const hasSubmenu = item.subNav && 
                                                  Array.isArray(item.subNav) && 
                                                  item.subNav.length > 0;

                                return (
                                    <li key={index} className={styles.menuItem}>
                                        <button
                                            className={styles.menuItemButton}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                handleItemClick(item, index);
                                            }}
                                        >
                                            <div className={styles.menuItemContent}>
                                                <span className={styles.menuItemIcon}>{item.icon}</span>
                                                <span className={styles.menuItemLabel}>{item.title}</span>
                                            </div>
                                            {hasSubmenu && (
                                                <LuChevronDown 
                                                    className={`${styles.expandIcon} ${isExpanded ? styles.expandIconOpen : ''}`}
                                                    size={20}
                                                />
                                            )}
                                        </button>
                                        
                                        {hasSubmenu && isExpanded && item.subNav && (
                                            <ul className={styles.submenuList}>
                                                {item.subNav.map((subItem, subIndex) => (
                                                    <li key={subIndex}>
                                                        <button
                                                            className={styles.submenuItem}
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                e.stopPropagation();
                                                                handleSubmenuItemClick(subItem, item.title);
                                                            }}
                                                        >
                                                            <span>{subItem.title}</span>
                                                        </button>
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </li>
                                );
                            })}
                        </ul>
                    ) : (
                        <div className={styles.emptyState}>
                            <p>{translate("sidebar.menu.noOptions")}</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default MenuDrawer;

